import { ContactCard } from "@/components/ui/contact/contactCard";
import {
  MbscHero,
  MbscOverview,
  MbscHowItWorks,
  MbscFeatures,
  MbscDevelopers,
  MbscStatusLifecycle,
  MbscChains,
  MbscUseCases,
  MbscSecurity,
  MbscStructuredData,
} from "@/components/mbsc";

type MBSCPageProps = {
  onNavigate?: (path: string) => void;
};

export function MBSCPage({ onNavigate }: MBSCPageProps) {
  return (
    <article itemScope itemType="https://schema.org/SoftwareApplication">
      <meta itemProp="name" content="MBSC — Monobundle Stablecoin Core" />
      <meta itemProp="applicationCategory" content="FinanceApplication" />
      <meta itemProp="operatingSystem" content="Web" />

      <MbscHero onNavigate={onNavigate} />
      <MbscOverview />
      <MbscHowItWorks />
      <MbscFeatures />
      <MbscDevelopers />
      <MbscStatusLifecycle />
      <MbscChains />
      <MbscUseCases />
      <MbscSecurity />

      <section id="contact" className="px-6 py-20 md:px-12">
        <div className="mx-auto max-w-4xl">
          <ContactCard sendLeadFormConversion />
        </div>
      </section>
      <MbscStructuredData />
    </article>
  );
}
